/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useTranslation } from "react-i18next";
import { SVGIcons } from "cms/icons/svg-icons";

const EmptyComponentList = () => {

    const { t } = useTranslation();

    return (
        <div className={"empty-component-list component-list-scroll"}>
            <SVGIcons.common.Clouds />
            <span>{t("Components.noComponentListAvailable")}</span>
        </div>
    );
};

export { EmptyComponentList };
